import React from "react"
import { useTheme } from '~/ui/styled'
// import { observer } from "mobx-react-lite"
import { StartFlex, ColumnFlex, CenterFlex, Text, Button, IconFont } from "~components/El"
import { ChannelChatInfo } from "~models/chat/channel-chat-info"
interface Props {
  isCurrentUserIsAdmin: boolean,
  channelChatInfo: ChannelChatInfo | null,
  onSubscribe: () => void
}
const ChannelMode: React.FC<Props> = ({ channelChatInfo, isCurrentUserIsAdmin, onSubscribe }) => {
    const theme = useTheme()
    return (
        <ColumnFlex width="100%" padding="8px 12px" bg={theme.colors.blockBackground}>
            <StartFlex width="100%" height="auto">
                <CenterFlex>
                    <IconFont name="hyyz" size={12} color={theme.colors.primary} />
                    <Text fontSize={12} color={theme.colors.primary} ml="6px">担保金额：¥{channelChatInfo?.total_amount || 0}</Text>
                </CenterFlex>
            </StartFlex>
            
            {!isCurrentUserIsAdmin && (
                <Button
                    width="100%"
                    height="44px"
                    mt="10px"
                    borderRadius="8px"
                    bg={theme.colors.primary}
                    onClick={onSubscribe}
                >
                    <Text fontSize={16} color={theme.colors.textLight} fontWeight={600}>取消订阅</Text>
                </Button>
            )}
        </ColumnFlex>
    )
}
export default React.memo(ChannelMode)
